import React, { FC, ReactNode, useEffect, useRef } from "react";
import classNames from "classnames";

import { Button } from "../Button";
import Icon from "../Icon";

// TODO: Refactor with a better approach that doesn't couple this util
// with a UI component
import { showVideoAskModal } from "../../../utils/dom";

type Props = {
  isOpen: boolean;
  close: () => void;
  children: ReactNode;
  className?: string;
  dataTest?: string;
};

export const BottomSheet: FC<Props> = ({
  isOpen,
  close,
  children,
  className,
  dataTest,
}) => {
  const container = useRef<HTMLDivElement>(null);

  const onClose = () => {
    close();
    // This function also shows the Intercom button
    showVideoAskModal(true);
  };

  useEffect(() => {
    if (container.current && isOpen) {
      // This function also hides the Intercom button
      showVideoAskModal(false);
      container.current.scrollTop = 0;
    }
  }, [isOpen]);

  return (
    <div data-test={dataTest} className="fixed bottom-0 !z-[50]">
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 !z-[50]"
          onClick={onClose}
          data-test={`${dataTest}-overlay`}
        ></div>
      )}

      {/* Bottom Sheet */}
      <div
        className={classNames(
          className,
          "fixed bottom-0 left-0 right-0 delay-100 transition-transform rounded-t-xl bg-white !z-[50]",
          {
            "translate-y-0": isOpen,
            "translate-y-full": !isOpen,
          }
        )}
        data-test={`${dataTest}-sheet`}
      >
        <Button
          className="mt-1 ml-2"
          icon
          onClick={onClose}
          variant={Button.variant.TERTIARY}
          size={Button.size.SMALL}
          data-test={`${dataTest}-close-button`}
        >
          <Icon icon="Close" size={24} className="theme-text" />
        </Button>

        <div
          className="max-h-[calc(85dvh)] overflow-y-auto mb-4"
          ref={container}
        >
          {isOpen && children}
        </div>
      </div>
    </div>
  );
};
